import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) {
      navigate("/login", { replace: true });
      return;
    }
    api
      .post("/auth/google/session", { session_id: sid })
      .then((r) => {
        setUser(r.data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true });
      })
      .catch(() => {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/login", { replace: true });
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gtscream">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="w-8 h-8 text-gtsorange animate-spin" />
        <p className="text-sm text-muted-foreground">Memproses login...</p>
      </div>
    </div>
  );
}
